import LoanFeesSubTabFundingShieldRedesign, {
  FundingShieldHeaderBar,
} from "../../LoanDrilldownFeesTab/tabs/LoanFeesSubTabFundingShieldRedesign";
import { PaneHeader, PaneShell } from "./PaneShell";

/**
 * Funding Shield, as a full-height workspace.
 *
 * The card is sized to the viewport and the SCROLLING happens inside the form
 * column, not on the page: the sheet has five sections and a live PDF beside it,
 * and scrolling the whole card pushed the preview off screen exactly when you
 * needed to check it. So the shell is fixed-height, its body carries no padding
 * of its own (the form column owns that, inside its own scroll), and the preview
 * simply stays put.
 *
 * The loan-status bar (status / date requested / files on file) is hoisted into
 * the pane HEADER rather than sitting above the form. It is loan state, not part
 * of the sheet — putting it in the header says so, and keeps it visible while the
 * form scrolls underneath. The component still renders it inline for the Closing
 * tab, which has no header to hoist it into; `showHeaderBar={false}` opts out.
 */
const FundingShieldPane = () => (
  <PaneShell
    sx={{
      // Never taller than the content area. `maxHeight` rather than a fixed
      // height so a short viewport still gets a usable card, and `overflow:
      // hidden` so the square-cornered preview column is clipped back to the
      // card's radius (safe here — nothing inside is position:sticky any more).
      height: "calc(100vh - 218px)",
      maxHeight: "calc(100vh - 218px)",
      minHeight: 520,
      overflow: "hidden",
    }}
    bodySx={{
      p: 0,
      flexGrow: 1,
      minHeight: 0,
      display: "flex",
    }}
    header={
      <PaneHeader
        wrap={false}
        title="Funding Shield"
        subtitle="Wire-fraud verification against the closing agent's instructions. Build the request PDF from loan data, file it to the loan, then email it."
        actions={<FundingShieldHeaderBar />}
      />
    }
  >
    <LoanFeesSubTabFundingShieldRedesign showHeaderBar={false} />
  </PaneShell>
);

export default FundingShieldPane;
